import type { Portfolio } from '@/hooks/usePortfolio';

const analysisKey = 'PORTFOLIO_ANALYSIS';

type AnalysisType =
  | ''
  | 'PerformanceTimeseries'
  | 'DiversificationAcrossIndustries';

export const getAnalysisQueryKey = <T extends object>(
  portfolioId: Portfolio['id'],
  type: AnalysisType = '',
  args: T = {} as T
): [typeof analysisKey, Portfolio['id'], AnalysisType, T] => {
  return [analysisKey, portfolioId, type, args];
};
